import type { PrePublishCheckCode } from 'services/api';

interface ErrorCodeTranslation {
  title: string;
  description: string;
}

const translateConfig: Record<PrePublishCheckCode, ErrorCodeTranslation> = {
  NO_ROOM_FOR_SUBJECT: {
    title: 'Нет кабинета',
    description:
      'Нет кабинета для предмета. Для каждого предмета учебной программы должно быть как минимум одно помещение, где его можно преподавать (например, лаборатория для химии)',
  },
  NO_TEACHER_FOR_CLASS_SUBJECT: {
    title: 'Нет преподавателя',
    description:
      'Нет преподавателя по конкретному предмету и для конкретного класса. (например, "Нет преподавателя по «Физике» для 8-9 классов"). Должен быть как минимум один квалифицированный учитель для связки предмет-класс',
  },
  NO_TEACHER_FOR_GROUP_CLASS: {
    title: 'Обязательный преподаватель для группового занятия',
    description:
      'Нет преподавателя по конкретному предмету и для конкретной группы. (например, "Нет преподавателя в группе 1 по «Иностранному языку»).',
  },
  CLASS_CAPACITY_EXCEEDED: {
    title: 'Превышение количества слотов',
    description:
      'Для каждого класса общее количество учебных часов в неделю не может превышать доступное количество слотов (дней × уроков в день)',
  },
  ROOM_CAPACITY_EXCEEDED: {
    title: 'Превышение количества мест',
    description:
      'По каждому предмету общее количество учебных часов (по всем предметам) не может превышать количество мест, выделенных для данного предмета аудиториями (количество аудиторий × количество мест в неделю)',
  },
  MISSING_OR_INVALID_SUBJECT_DIFFICULTY: {
    title: 'Сложность предмета',
    description:
      'Предмет должен иметь допустимое значение сложности (например, положительное, в пределах допустимого диапазона)',
  },
  NO_TEACHER_FOR_MANDATORY_IMPLICIT_LESSON: {
    title: 'Обязательный преподаватель',
    description:
      'Для каждого обязательного неявного предмета "Разговоры о важном" или "Россия мои горизонты" должен быть преподаватель',
  },
  NO_ROOM_FOR_MANDATORY_IMPLICIT_LESSON: {
    title: 'Обязательный кабинет',
    description:
      'Для каждого обязательного неявного предмета "Разговоры о важном" или "Россия мои горизонты" должна быть аудитория',
  },
};

export const translateErrorCode = (code: string): ErrorCodeTranslation =>
  translateConfig[code as PrePublishCheckCode] ?? {
    title: 'Неизвестное нарушение',
    description: `Обнаружено нарушение с кодом «${code}», для которого пока нет описания. Обратитесь к администратору системы.`,
  };
